import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs, validationSchemaEnded } from '../constants';
import { toast } from 'react-toastify';
import FormMunicipalityEnded, {
  MunicipalityEndedForm,
} from 'system/geographic/components/municipality/ended';
import { Municipality } from 'shell/models/municipality';
import { HttpResponse } from 'shell/models/http-response';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import {
  transformRequestMunicipalityEnded,
  transformResponseMunicipalityEnded,
} from 'system/geographic/utils/transformer-municipality-ended';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const MunicipalityEndedEditPage = (): React.ReactElement => {
  const params = useParams();

  const updateMunicipality = useHttpClient(`${__MUNICIPALITY_API_URL__}/geo/comune/`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
    },
  });

  const [municipalityData] = useHttpFetch<HttpResponse<Municipality>, MunicipalityEndedForm>(
    `${__MUNICIPALITY_API_URL__}/geo/comune/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: transformResponseMunicipalityEnded,
    }
  );

  const municipality = municipalityData.data as MunicipalityEndedForm;

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: MunicipalityEndedForm | undefined) => {
      const data = transformRequestMunicipalityEnded(formValues);
      (
        updateMunicipality({
          url: `/${formValues?.isForeign ? 'straniero' : 'italiano'}/${params.id}`,
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/comune');
      });
    },
    [updateMunicipality, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMunicipalityCrumbs, { name: 'Modifica Comune Soppresso' }]} />
      {municipalityData.isLoading || municipalityData.hasErrors || !municipality ? undefined : (
        <FormMunicipalityEnded
          title="Modifica Comune Soppresso"
          onOk={onSubmit}
          validationSchema={validationSchemaEnded}
          isEdit
          initialValues={municipality}
          onCancel={() => {
            navigate('/sistema/geografiche/comune');
          }}
        />
      )}
    </Fragment>
  );
};

MunicipalityEndedEditPage.displayName = 'Municipality edit ended page component';

export default MunicipalityEndedEditPage;
